import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { resolveRentalReview } from '../../../api/rentals';

const useResolveRentalReview = (options?: Omit<UseMutationOptions, 'mutationFn'>) => {
  return useMutation({
    mutationFn: resolveRentalReview,
    ...options,
  });
};

export default useResolveRentalReview;
